module.exports = __webpack_public_path__ + "img/54862fc.png";